import React from "react";

import { SupIconButton, SupText, SupIconCheckbox, SupCheckboxChecked } from "@repo/core-ui";

interface GridBarFiltersAtomListProps {
  values: string[];
  selectedValues: string[];
  onChange: (value: string) => void;
}

export default function GridBarFiltersAtomList({ values, onChange, selectedValues }: GridBarFiltersAtomListProps) {
  return (
    <nav className="mt-auto flex min-w-[223px] flex-col justify-center space-y-1 whitespace-nowrap">
      {values.map((singleValue, index) => (
        <li className="flex cursor-pointer items-center justify-between p-2 hover:bg-primary-300" onClick={() => onChange(singleValue)} key={`filter-list-item-${values}-${index}`}>
          <SupIconButton active={selectedValues.includes(singleValue)} activeIcon={<SupCheckboxChecked />}>
            <SupIconCheckbox />
          </SupIconButton>
          <SupText variant="caption">{singleValue.replace(/_/g, " ")}</SupText>
        </li>
      ))}
    </nav>
  );
}
